import { lazy } from "react";

const routes = [
  {
    path: "/org-app-mapping",
    element: lazy(() => import("../../pages/Saas/OrgAppMapping")),
  },
  {
    path: "/org-app-mapping/create",
    element: lazy(
      () => import("../../pages/Saas/OrgAppMapping/create-editOrgAppMapping"),
    ),
  },
  {
    path: "/org-app-mapping/edit/:id",
    element: lazy(
      () => import("../../pages/Saas/OrgAppMapping/create-editOrgAppMapping"),
    ),
  },
];

export default routes;
